/**
 * Smartfit-Callback: stellt die empfohlene Variante ein.
 *  – sucht nach dem Hidden-Input  <input name="id">
 *  – aktualisiert Preis, Lager & URL
 *  – passt das angezeigte Custom-Dropdown (optional) an
 */
function selectSuggestedSize(ev) {
  const barcode = String(ev?.detail?.code);              // kommt von Smartfit
  if (!barcode) return;

  /* 1) Variante via BARCODE im globalen Product-Objekt finden */
  const product = window.shopifyProduct || window.product;
  const variant = product?.variants?.find(v => String(v.barcode) === barcode);
  if (!variant) {
    console.warn('❌ Barcode nicht im product-Objekt:', barcode);
    return;
  }

  /* 2) Hidden-Input <input name="id"> auf die Variant-ID setzen */
  const variantInput = document.querySelector(
    'form[action*="/cart"] input[name="id"]'
  );
  if (!variantInput) {
    console.error('❌ Kein <input name="id"> im Produkt-Formular gefunden.');
    return;
  }

  variantInput.value = variant.id;                                 // neue ID
  variantInput.dispatchEvent(new Event('input',  { bubbles: true }));
  variantInput.dispatchEvent(new Event('change', { bubbles: true }));
  console.log('🖱️ Hidden-Input gesetzt → Variant-State aktualisiert');

  /* 3) OPTIONAL – sichtbares Custom-Dropdown synchron halten ------------- */
  const li      = document.querySelector(
    `li.custom-select__option[data-code="${barcode}"]`
  );
  const btn     = li?.closest('.custom-select')?.querySelector('.custom-select__btn');
  if (li && btn) {
    btn.querySelector('span').textContent = li.textContent.trim(); // Label
    li.closest('ul')?.querySelectorAll('.is-active')               // alte Markierung weg
       .forEach(el => el.classList.remove('is-active'));
    li.classList.add('is-active');                                 // neue Markierung
  }
}

window.selectSuggestedSize = selectSuggestedSize;